import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'scitis-inline-edit-input-field',
    templateUrl: './inline-edit-input-field.component.html',
    styleUrls: ['./inline-edit-input-field.component.scss'],
    standalone: false
})
export class InlineEditInputFieldComponent {

  @Input()
  isEditable: boolean = false;

  @Input()
  value: any;

  @Input()
  type: string = 'text';

  @Input()
  fieldValueEditClass: string = '';

  @Output()
  edit: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  cancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  save: EventEmitter<any> = new EventEmitter<any>();

  modelValue?:any = '';

  inactiveClass = 'form-inline-edit-inactive';

  ngOnInit() {
    this.modelValue = this.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.value) this.modelValue = this.value;
  }

  get valueEditClass(): string {
    if (this.fieldValueEditClass) {
      return this.fieldValueEditClass;
    }
    return this.inactiveClass;
  }

  onEdit(value: any) {
    this.edit.emit(value);
  }

  onCancel() {
    this.modelValue = this.value;
    this.cancel.emit(true);
  }

  onSave(newValue: any) {
    this.save.emit(newValue);
    newValue.blur();
  }

  onBlur(event: FocusEvent, value: HTMLInputElement, cancel: HTMLButtonElement)  {
    if(event.relatedTarget === cancel)
      return;
    this.onSave(value);
  }

  onEsc(input: HTMLInputElement) {
    this.onCancel();
    input.blur();
  }
}
